import { harFormatter } from './formatters/har';
import { SessionStorage } from './storage';
import { Xhr as XhrObserver } from './observers/xhr';
import { Receiver } from './receiver';

import { RequestSnifferOptions } from './types';

/**
 * @param Options
 * @param Options.filters
 * @param Options.storage
 * @param Options.observers
 * @param Options.formatter
 * @param Options.format
 * @param Options.masks
 */
function RequestSniffer({
  filters,
  storage,
  observers,
  masks,
  format,
}: RequestSnifferOptions) {
  const Observer = (() => {
    if (observers?.xhr) {
      return XhrObserver;
    } else if (observers?.fetch) {
      throw new Error('Fetch in progress.');
    }

    return XhrObserver;
  })();
  const Storage = (() => {
    if (storage === 'SessionStorage') {
      return SessionStorage;
    }

    return storage;
  })();
  const formatter = (() => {
    if (format === 'har') {
      return harFormatter;
    }

    return format;
  })();

  const receiver = new Receiver({
    filters,
    // TODO: Fix types
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    formatter,
    Observer,
    Storage,
    masks,
  });

  return receiver;
}

export { RequestSniffer };
